import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { Company } from '../../../../shared/models/company';

import { CartService } from '../../../../shared/services/cart.service';
import { OnlineOrdersService } from '../../../../shared/services/online-orders.service';

import { faWhatsapp, faCartShopping, faClipboardList } from '../../../../icons';

@Component({
    selector: 'app-bottom-navbar',
    templateUrl: './bottom-navbar.component.html',
    styleUrls: ['./bottom-navbar.component.scss'],
    standalone: false
})
export class BottomNavbarComponent implements OnInit {
  @Input() company: Company;
  cartItems: number;
  onlineOrderItems: number;

  faWhatsapp = faWhatsapp;
  faCartShopping = faCartShopping;
  faClipboardList = faClipboardList;

  constructor(private router: Router,
  	private route: ActivatedRoute,
    public cartServ: CartService,
    public ooServ: OnlineOrdersService) { }

  ngOnInit(): void {
    this.ooServ.fetch().subscribe(
      res => {
        this.onlineOrderItems = this.ooServ.n_active_items;
      },
      err => {},
      () => {}
    );
    this.cartItems = this.cartServ.n_items;
  }

  navCart() {
  	this.router.navigate(['carrinho'], {relativeTo: this.route});
  }
  navWhatsapp() {
    let encodedMsg = encodeURIComponent("Olá! Estou com uma dúvida: ");

    window.open(`https://wa.me/55${this.company.whatsapp_number}?text=${encodedMsg}`, "_blank");
  }
  navOrders() {
    this.router.navigate(['meus-pedidos'], {relativeTo: this.route});
  }

}
